<template>
  <div style="display: flex; justify-content: center;">
    <button class="acao-secundaria" v-if="!isEditing" @click="showInput">Adicionar parâmetro</button>
    <div v-else class="linha">
      <input ref="inputField" v-model="inputValue" type="text" @keydown.enter="finishInput" placeholder="Digite aqui..." />
      <button class="acao-secundaria" @click="finishInput">Cadastrar</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlusInput",
  data() {
    return {
      isEditing: false,
      inputValue: "",
    };
  },
  methods: {
    showInput() {
      this.isEditing = true;
      this.$nextTick(() => {
        this.$refs.inputField.focus();
      });
    },
    finishInput() {
      this.isEditing = false;
      this.$emit("input-finished", this.inputValue);
      this.inputValue = "";
    },
  },
};
</script>

<!-- <style scoped>
  button {
    font-size: 24px;
    cursor: pointer;
  }
  
  input {
    padding: 4px 8px;
  }
  </style> -->
